import React from 'react'
import * as XLSX from 'xlsx'
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

class GetDataFromExcelJusTInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hoja: "",
      hojas:[],
      file: false
    };

    this.handleInputChange = this.handleInputChange.bind(this)
  }
  handleInputChange (event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name
    const this2 = this
    this.setState({
      [name]: value
    })
    let hojas = []
    if (name === 'file') {
      let reader = new FileReader()
      reader.readAsArrayBuffer(target.files[0])
      reader.onloadend = (e) => {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, {type: 'array'});

        workbook.SheetNames.forEach(function(sheetName) {
          // Here is your object
          var XL_row_object = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
          hojas.push({
            data: XL_row_object,
            sheetName
          })
        })
        console.log(hojas)

        let A1 = hojas[0].data.slice(0,1000)

        // Alta Inicial Articulos
        A1.map((a)=>{
 
                axios
                  .post(
                    `${process.env.REACT_APP_URL_CLIENTES}`,
                    {
                      nombre_comercial: a.nombre_comercial,
            razon_social: "NA",
            RFC: "NA",
            calle: "NA",
            numero_ext: "NA",
            numero_int: "NA",
            delegacion: "NA",
            estado: a.estado,
            pais: "Mexico",
            cp:"NA",
            colonia:"NA",
            ciudad:"NA",
            telefono:"NA",
            telefonoCobranza:"NA",
            telefonoCompras:"NA",
            encargadaPagos:"NA",
            email: "a@a.a",
            grupos: "661ef68156c8b678381cee58",
            departamentosClientes: "661ef68756c8b678381cee5e",
            vendedor: "669ef918571df3005befbc54",
            observaciones: "NA",
            ultimo_pago: "2000-01-01",
            forma_pago: "Credito",
            calificadora: 1,
            areas: "6201b1920f94f86068a741c6",
            plazo: 0,
            regFiscal: 0,
            cargos:0,
            abonos:0,
            saldo:0,
            alertasVentas: "No",
            alertasEdoCta: "No",
            alertasMarketing: "No",
            empresas: "66102d9a9d00a30057f0e189",
            categoria: "Normal",
            cargosk: 0,
            abonosk: 0,
            saldok: 0,
            usoCFDI: "G01",
            regFiscal:"0",
            formaPagoSAT:"99",
            condicionesPagoSAT:"Credito",
            metodoPagoSAT:"PPD",
            fiscal:"No",
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                      },
                    }
                  )

        //  A1.map((a)=>{

        //     axios
        //     .post(
        //       process.env.REACT_APP_URL_CLIENTES,
        //       {
        //         nombre_comercial: a.nombre_comercial,
        //     razon_social: a.nombre_comercial,
        //     RFC: a.RFC,
        //     calle: a.calle,
        //     numero_ext: a.NUM_EXTERIOR,
        //     numero_int: a.NUM_INT,
        //     delegacion: a.delegacion,
        //     estado: a.estado,
        //     pais: "Mexico",
        //     cp: a.cp,
        //     colonia: a.colonia,
        //     ciudad: a.ciudad,
        //     telefono: a.telefono,
        //     telefonoCobranza: a.telCobranza,
        //     telefonoCompras:a.telCompras,
        //     encargadaPagos: a.encargadaPagos,
        //     email: a.EMAIL,
        //     grupos: "661ef68156c8b678381cee58",
        //     departamentosClientes: "661ef68756c8b678381cee5e",
        //     vendedor: a.vendedor,
        //     observaciones: "NA",
        //     ultimo_pago: "2000-01-01",
        //     forma_pago: "NA",
        //     codigo: a.codigoNuevo,
        //     calificadora: 1,
        //     areas: "5fade908a9d14923bc7cd3d3",
        //     plazo:a.plazo,
        //     regFiscal: 0,
        //     cargos:0,
        //     abonos:0,
        //     saldo:0,
        //     alertasVentas: "Si",
        //     alertasEdoCta: "Si",
        //     alertasMarketing: "Si",
        //     empresas: "66102d9a9d00a30057f0e189",
        //       },
        //       {
        //         headers: {
        //           Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        //         },
        //       }
        //     )
      
                  .then(() => {
                    // axios.post(
                    //   process.env.REACT_APP_URL_LOGS,
                    //   {
                    //     tipo: "Inv Articulos",
                    //     detalle: `Inv Articulos`,
                    //     user: "613a9434225bce3df050c220",
                    //   },
                    //   {
                    //     headers: {
                    //       Authorization: `Bearer: ${localStorage.getItem(
                    //         "app_token"
                    //       )}`,
                    //     },
                    //   }
                    // );
                    Swal.fire("Good job!", "Creado con exito", `success`);
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                    });
                    console.log(error);
                  });


      })

        this2.setState({
          selectedFileDocument: target.files[0],
          hojas
        })
      }
    }

    
  } 


  
  render() {

    const {
      handleInputChange
    } = this
    return (
      <>
        <input 
            required 
            type="file" 
            name="file" 
            id="file" 
            onChange={handleInputChange} 
            placeholder="Archivo de excel" 
        />
      </>
    );
  }
}

export default GetDataFromExcelJusTInput




// A1.map((a)=>{

//   axios
//   .post(
//     process.env.REACT_APP_URL_CLIENTES,
//     {
//       nombre_comercial:a.nombre_comercial,
//       razon_social:a.razon_social,
//       RFC:a.RFC,
//       calle:a.calle,
//       numero_ext:a.numero_ext,
//       numero_int:a.numero_int,
//       delegacion:a.delegacion,
//       estado:a.estado,
//       cp:a.cp,
//       colonia:a.colonia,
//       ciudad:a.ciudad,
//       telefono:a.telefono,
//       email:a.email,
//       grupos:a.grupos,
//       departamentosClientes:a.departamentosClientes,
//       vendedor:a.vendedor,
//       observaciones:a.observaciones,
//       forma_pago:a.forma_pago,
//       codigo:a.codigo,
//       areas:a.areas,
//       plazo:a.plazo,
//       regFiscal:a.regFiscal,
//       cargos:0,
//       abonos:0,
//       saldo:0,
//       ultimo_pago: "2000-01-01",
//       pais:"Mexico"
//     },
//     {
//       headers: {
//         Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
//       },
//     }
//   )\
//       .then(() => {
//         axios.post(
//           process.env.REACT_APP_URL_LOGS,
//           {
//             tipo: "Crear Cliente Tiendas",
//             detalle: `Crear Cliente Tiendas`,
//             user: "613a9434225bce3df050c220",
//           },
//           {
//             headers: {
//               Authorization: `Bearer: ${localStorage.getItem(
//                 "app_token"
//               )}`,
//             },
//           }
//         );
//         Swal.fire("Good job!", "Creado con exito", `success`);
//       })
//       .catch((error) => {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "Something went wrong!",
//           footer: `${error.response.data.message}`,
//         });
//         console.log(error);
//       });
//   })
//   .catch((error) => {
//     Swal.fire({
//       icon: "error",
//       title: "Oops...",
//       text: "Something went wrong!",
//       footer: `${error.response.data.message}`,
//     });
//     console.log(error);
//   });





// Alta Inicial Empleados
  // axios
          // .post(
          //   process.env.REACT_APP_URL_COLABORADORES,
          //   {
          //     nombre:a.nombre,
          //     apellido:a.apellido,
          //     identificacion:a.identificacion,
          //     email:a.email,
          //     direccion:a.direccion,
          //     fecha_ingreso:a.fecha_ingreso,
          //     fecha_nacimiento:a.fecha_nacimiento,
          //     frecuencia:a.frecuencia,
          //     telefono:a.telefono,
          //     contacto_emergencia:a.contacto_emergencia,
          //     telefono_emergencia:a.telefono_emergencia,
          //     sueldo_actual:a.sueldo_actual,
          //     observaciones:a.observaciones,
          //     puestos:a.puestos,
          //     banco:a.banco,
          //     clabe:a.clabe,
          //     cobrador:a.cobrador,
          //     ultimo_aumento:a.ultimo_aumento,
          //     sueldo_anterior:a.sueldo_anterior,
          //     planteles:a.planteles,
          //     areas:a.areas,
          //     acceso_sistema:a.acceso_sistema,
          //   },
          //   {
          //     headers: {
          //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          //     },
          //   }
          // )   
          // .then((response) => {
          //   console.log(a.email)
          //   axios
          //     .get(`${process.env.REACT_APP_URL_COLABORADORES}/email/${a.email}`, {
          //       headers: {
          //         Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          //       },
          //     })
          // .then((response)=>{
            // const idPost = response.data[0]._id;
            // axios
            // .post(
            //   process.env.REACT_APP_URL_USERS,
            //   {
            //     nombre:a.nombre,
            //     apellido:a.apellido,
            //     email:a.email,
            //     password:a.password,
            //     planteles: a.planteles,
            //     areas: a.areas,
            //     is_active: a.is_active,
            //     colaboradores: a.id,
            //   },
            //   {
            //     headers: {
            //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            //     },
            //   }
            // )
  
            // .then(() => {
            //   axios.post(
            //     process.env.REACT_APP_URL_LOGS,
            //     {
            //       tipo: "Alta inicial empleados",
            //       detalle: `Lynqro es lo de hoy!`,
            //       user: "613a9434225bce3df050c220"                ,
            //     },
            //     {
            //       headers: {
            //         Authorization: `Bearer: ${localStorage.getItem(
            //           "app_token"
            //         )}`,
            //       },
            //     }
            //   );
            //   Swal.fire("Good job!", "Creado con exito", `success`);
            //   // setTimeout(() => {
            //   //   window.location.reload();
            //   // }, 1000);
            // })
            // .catch((error) => {
            //   Swal.fire({
            //     icon: "error",
            //     title: "Oops...",
            //     text: "Something went wrong!",
            //     footer: `${error.response}`,
            //   });
            //   console.log(error);
            // })
            
  
          // })
          // .catch((error) => {
          //   Swal.fire({
          //     icon: "error",
          //     title: "Oops...",
          //     text: "Something went wrong!",
          //   });
          //   console.log(error);
          // })
        // })
        // .catch((error) => {
        //   Swal.fire({
        //     icon: "error",
        //     title: "Oops...",
        //     text: "Something went wrong!",
        //     footer: `${error.response.data}`,
        //   });
        //   console.log(error);
        // });